export enum InstructionDialogs {
  ADD_INSTRUCTION = "addInstruction",
  EDIT_INSTRUCTION = "editInstruction",
}

export enum InstructionStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}
